<div class="dialog">
    <div class="dialog-title pt-3 pl-2">
        <h6 class="semi-bold">Upload Your Shipment Terms & Conditions <img class="mt-1 pr-2" src="assets/svg/close-white.svg" alt="close" (click)="close()"></h6>
    </div>
        <div class="content">
        <div [formGroup]="termsForm">
            <h6 class="mt-0">Shipment Terms</h6>
                <div class="col-md-6 px-0">
                    <select class="select arrow-img"
                    formControlName="partnerShipmentTerms">
                    <option value="">Select Shipment Terms</option>
                    <option *ngFor="let option of shippingTermList" [value]="option">{{option}}
                    </option>
                </select>
                <span class="form-error-text" style="float: left;" *ngIf="isSubmitted && termsForm.controls.partnerShipmentTerms.invalid">Shipment Type Required</span>
                </div>
                <h6 class="mt-4">Shipment Instructions</h6>
                <div class="custom-form mt-3">
                <!-- <div class="mt-3"> -->
                    <textarea rows="6" formControlName="shipment_string" class="container-fluid" name="shipment_string"></textarea>
                <!-- </div> -->
            </div>
        </div>

        <div class="row button mt-4">
            <button class="white button-semibold mr-2" (click)="close()">Cancel</button>
            <button class="orange button-semibold ml-2" (click)="submit()">Confirm</button>
        </div>
    </div>
</div>